import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';

import { FieldInterventionBloc } from '@connect-services/client/blocs/field-intervention.bloc';
import {
    ContextLayersDisplayModeEnum,
    FieldInterventionContextLayersComponent,
} from '@connect-services/client/components/field-intervention-context-layers/field-intervention-context-layers.component';
import { FieldInterventionDetailsComponent } from '@connect-services/client/components/field-intervention-information/field-intervention-details/field-intervention-details.component';
import { FieldInterventionContextLayerOption } from '@connect-services/client/services/field-intervention.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FieldInterventionContextLayersComponent, FieldInterventionDetailsComponent, RessourcesModule],
    selector: 'app-field-intervention-information',
    styleUrl: './field-intervention-information.component.scss',
    templateUrl: './field-intervention-information.component.html',
})
export class FieldInterventionInformationComponent {
    public readonly contextLayersOptions = input<FieldInterventionContextLayerOption[]>([]);
    public readonly contextLayersSelected = input<FieldInterventionContextLayerOption[]>([]);
    public readonly contextLayersSelectionChange = output<string[]>();
    public readonly description = input.required<string>();
    public readonly isFlexRow = input<boolean>(false);
    public readonly isPlanningDisplay = input<boolean>(false);
    public readonly showContextLayers = input<boolean>(false);

    protected readonly fieldInterventionBloc = inject(FieldInterventionBloc);
    protected readonly FieldInterventionContextLayersDisplayModeEnum = ContextLayersDisplayModeEnum;
}
